<template>
  <transition name="fade">
    <div class="lyf-ui-toast" :class="{ 'have-button': btnText }" v-show="visible">
      <div class="lyf-ui-toast-content">
        <lyf-icon v-if="icon" :icon="icon" />
        <span class="lyf-ui-message">{{ message }}</span>
        <lyf-button size="small" v-if="btnText">{{ btnText }}</lyf-button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LyfToast',
  props: {
    visible: Boolean,
    message: String,
    duration: Number,
    icon: String,
    btnText: String
  }
}
</script>

<style scoped>
.lyf-ui-toast {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 300;
  width: 100%;
  height: 100%;
}

.lyf-ui-toast .lyf-ui-toast-content {
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 224px;
  height: 32px;
  overflow: hidden;
  padding: 0 var(--space_8);
  border-radius: var(--space_4);
  background-color: var(--N1_2);
  color: var(--font-color_4);
  white-space: nowrap;
  transform: translate3d(-50%, -50%, 0);
}

.lyf-ui-toast .lyf-ui-toast-content .lyf-icon {
  margin-right: var(--space_4);
}

.lyf-ui-toast .lyf-ui-toast-content .lyf-ui-message {
  overflow: hidden;
  font-size: 16px;
  line-height: 24px;
}

.lyf-ui-toast.have-button .lyf-ui-toast-content {
  justify-content: space-between;
  max-width: none;
  height: 40px;
  left: var(--space_16);
  right: var(--space_16);
  margin: 0 auto;
  transform: translateX(0);
}

.lyf-ui-toast.have-button .lyf-ui-toast-content .lyf-ui-message {
  flex: 1;
}
</style>
